import { getAxiosInstance } from "../ApiConfig";

const LoginToken = localStorage.getItem('cx_token');
const headers = {};
headers.Authorization = `Bearer ${LoginToken}`;

async function FetchAllNotes(page, user) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/notes/${page}/${user}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchAllNotesbyduration(page, duration) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/selectedAllByDuration/${page}/${duration}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function NotesDetailData(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/notes/${id}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function UserNotes() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/UserNotes`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function deleteNoteId(id) {
    try {
        const data = await getAxiosInstance().delete(`/usermgmt/notes/${id}`, { headers });
        return data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function NoteSave(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/saveNotes`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function NoteUpdate(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/notes/${id}`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
export {
    FetchAllNotes,
    FetchAllNotesbyduration,
    NotesDetailData,
    deleteNoteId,
    NoteSave,
    NoteUpdate,
    UserNotes,
}